<template>
  <div class="page">

    <accordion :multiple="true" :activeIndex="[1]" >

      <accordion-tab>
        <template #header>
          <span>Fatture pronte per lo SDI</span>&nbsp;<span>({{ data.fatture.length }})</span>
        </template>

        <data-table 
          :value="data.fatture" 

          responsiveLayout="scroll"

          v-model:selection="selectedItems" 
          dataKey="numero"

          sortMode="multiple" 

          :paginator="true" 
          :rows="10"
          :rowsPerPageOptions="[10,25,50]"
          paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown" 
          currentPageReportTemplate="{first} a {last} di {totalRecords} elementi"
        >
          <template #empty>
            <div class="box-center">Nessun dato trovato.</div>
          </template>

          <column selectionMode="multiple" headerStyle="width: 3em"></column>
          <column field="numero" header="Numero Fattura"></column>
          <column field="ragsoc" header="Cliente" sortable></column>
          <column field="data_emissione" header="Data Emissione" sortable>
            <template #body="{data}">
              <span>
                {{ (data['data_emissione'] !== null)? moment(data['data_emissione']).format('DD/MM/YYYY'): '' }}
              </span>
            </template>
          </column>
          <column field="data_scadenza" header="Data Scadenza" sortable>
            <template #body="{data}">
              <span>
                {{ (data['data_scadenza'] !== null)? moment(data['data_scadenza']).format('DD/MM/YYYY'): '' }}
              </span>
            </template>
          </column>
          <column field="totale_fattura" header="Importo" sortable>
            <template #body="{data}">
              <span>
                {{ currencyFormatter.format( (data['totale_fattura'] !== null)? data['totale_fattura'] : 0 ) }} 
              </span>
            </template>
          </column>
        </data-table>

        <div v-if="selectedItems.length > 0" class="p-d-flex p-p-3 card">
          <prime-button label="Crea File per SDI" icon="pi pi-file-pdf" class="mb-auto" @click="onMakeSdiArchiveButton($event)" />
        </div>

      </accordion-tab>

      <accordion-tab>
        <template #header>
          <span>Scarica file ZIP</span>
        </template>

        <tab-view v-model:activeIndex="yearActiveTabIndex" @tab-change="onYearTabChange">
          <tab-panel v-for="year in years" :key="year" :header="year">

            <tab-view v-model:activeIndex="monthActiveTabIndex">
              <tab-panel v-for="month in months" :key="month" :header="month">

                <data-table :value="data.listaFiles[month]" responsiveLayout="scroll">
                  <column field="data" header="Data"></column>
                  <column field="ora" header="Ora"></column>
                  <column :exportable="false">
                    <template #body="{data}">
                      <prime-button 
                        label="Scarica File"
                        class="p-button-rounded p-button-success mr-2" 
                        @click="onGetZipButton(data.key)" 
                      />
                    </template>
                  </column>
                </data-table>

              </tab-panel>
            </tab-view>

          </tab-panel>
        </tab-view>

      </accordion-tab>

    </accordion>

  </div>
</template>

<script>
import moment from 'moment'

import Service from '@/services/ask-management/modulo-sdi-fatture-clienti-service'

import PrimeButton from 'primevue/button'

export default {
  components:{
    PrimeButton,
  },

  data(){
    return {
      moment,

      currencyFormatter: new Intl.NumberFormat('it-IT', {
        style: 'currency',
        currency: 'EUR',
      }),

      years: [],
      yearActiveTabIndex: 0,

      months: [],
      monthActiveTabIndex: 0,

      selectedItems: [],

      data: {
        fatture: [],
        listaFiles: {},
      }

    }
  },

  created(){
    this.service = new Service(this.$http, this.$eventBus)

    this.years = [...Array(2).keys()].map(i => new Date().getFullYear() - i)

    this.getFatturePerSdi()
    this.getArchives()
  },

  mounted(){
      
  },

  methods:{
    getFatturePerSdi(){
      this.service.getFatturePerSdi().then((res) => {
        this.data.fatture = res.items
      })
    },

    getArchives(){
      this.service.getArchivesByYear(this.currentYear)
      .then((res) => {
        this.data.listaFiles = Object.entries(res.item)
        .map(([source, items]) =>{
          return {
            [source]: items.map((el) => {
              const parts = el.split('_')
              const data = parts[0].split('-').reverse().join('/')
              const ora = parts[1].split('-').join(':')

              return{
                'key': el,
                data,
                ora,
              }
            })
          }
        })
        .reduce( ( acc, el ) => Object.assign(acc, el), Object.create(null) )

        this.months = Object.keys(res.item)
      })
    },

    ////

    onMakeSdiArchiveButton(/** event **/){
      const filters = {
        'fattura_vendita.numeri': this.selectedItems.map((el) => el.numero)
      }
      
      this.service.makeSdiArchive(filters)
      .then((res) => {
        if(res.success){
          this.getFatturePerSdi()
          this.getArchives()
        }
      })
    },

    onYearTabChange(/** evt **/){
      this.months = []
      this.monthActiveTabIndex = 0

      this.data.listaFiles = {}

      this.getArchives()
    },

    onGetZipButton(fileName){
      this.service.downloadZip(fileName)
    },
      
  },

  computed:{
    currentYear: function(){
      return this.years[this.yearActiveTabIndex]
    },
  },
}
</script>

<style scoped>
.box-center{
  display: flex; 
  align-items: center; 
  justify-content: center;
}
</style>
